/**
 * Comments component for single pages
 */

// Import statements
import React, {Component} from "react"
import SingleComment from "./single-comment";
import CommentWrapper from "./comment-wrapper";
import CommentForm from "./comment-form"

/**
 * Define the BlogComments constant
 */
class BlogComments extends Component {

    // render the component
    render(props) {

        // sort comments in the right order
        const sortComments = allComments => {
            let sortedComments = allComments.filter(
                comment => comment.node.parentDatabaseId === 0
            )
            sortedComments = sortedComments.map(comment => {
                return getChildComments(comment, allComments)
            })
            return sortedComments
        }

        // get the child comments
        const getChildComments = (comment, allComments) => {
            const parentId = comment.node.databaseId
            let children = allComments.filter(
                comment => comment.node.parentDatabaseId === parentId
            )
            if (children.length !== 0) {
                let allchildren = children.map(child =>
                    getChildComments(child, allComments)
                )
                return [comment, allchildren]
            }
            return comment
        }

        // render the comments
        const renderComments = (comment, index, post) => {
            if (!Array.isArray(comment)) {
                return <SingleComment comment={comment} index={index} post={post} key={`single-comment-${comment.id}`}/>
            } else {
                return (
                    <SingleComment comment={comment[0]} index={index} post={post}
                                   key={`single-comment-${comment[0].id}`}>
                        <CommentWrapper child="true" key={`comment-wrapper-${comment[1].id}`}>
                            {comment[1].map(comment => renderComments(comment, (index + 1), post))}
                        </CommentWrapper>
                    </SingleComment>
                )
            }
        }

        // function to render the comments
        let render = function (comment, index, post) {
            return renderComments(comment, index, post)
        }

        // get all comments and store in constant
        const allComments = this.props.comments

        // get this post
        const post = this.props.post

        // return the information
        return (
            <section id="comments" className="row">
                {allComments.edges.length > 0 ? (
                    <div className="col-md-8 col-lg-7 offset-lg-1" id="commentlist">
                        <h2>{allComments.edges.length} reacties op "{post.title}"</h2>
                        <CommentWrapper>
                            {sortComments(allComments.edges).map((comment, index) => render(comment, index, post))}
                        </CommentWrapper>
                    </div>
                ) : (
                    ''
                )}
                <div className="col-md-8 col-lg-7 offset-lg-1" id="commentform_wrapper">
                    <CommentForm postId={post.databaseId}/>
                </div>
            </section>
        )
    }
}

/**
 * Export the BlogComments variable
 */
export default BlogComments